import { render, staticRenderFns } from "./TheMain.vue?vue&type=template&id=654bf4fb&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"
import style0 from "./TheMain.vue?vue&type=style&index=0&id=654bf4fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bf4fb",
  null
  
)

export default component.exports